export default {

    methods: {
        convertJournalsToPdfAndPrint(journalId = 0, type = 'journal', orientation = 'portrait', treatmentId = null) {

            let printIframe = document.getElementById("print-iframe");

            if(!printIframe) {

                printIframe = document.createElement('iframe');
                printIframe.id = 'print-iframe';
                printIframe.name = 'print-iframe';
                printIframe.style.display = 'none';

                document.body.appendChild(printIframe);

            }

            // Setup the onload callback function
            printIframe.onload = function() {
                // A timeout is used to allow the iframe to render 100%
                setTimeout(() => {
                    printIframe.contentWindow.focus();
                    printIframe.contentWindow.print();
                }, 1000);

            };

            let ownerType = this.isGroupJournal ? 'client-group' : 'client';

            document.journalPrintForm.action = `/app/${ownerType}/${this.clientOrGroup.id}/journal/${journalId}/print/${type}`;

            document.journalPrintForm.orientation.value = orientation;

            if (treatmentId) {
                document.journalPrintForm.treatment.value = treatmentId;
            }

            var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                navigator.userAgent &&
                navigator.userAgent.indexOf('CriOS') === -1 &&
                navigator.userAgent.indexOf('FxiOS') === -1;

            // Safari needs to open a new tab to display the printable PDF file
            if(isSafari) {
                document.journalPrintForm.target = '_blank';
            }

            document.journalPrintForm.submit();
        },

        printAllJournals(orientation) {

            // Defaults to printing all journals and surveys
            this.convertJournalsToPdfAndPrint(0, 'journal', orientation);
        },

        printIndividualJournal(journalId, type, orientation) {

            // Individual journals need an ID and type. Can be a normal journal or survey entry
            this.convertJournalsToPdfAndPrint(journalId, type, orientation);
        },
    }
}
